var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useRef, useEffect } from 'react';
import { ftap } from 'fpoint';
import combineRefs from './lib/combine-refs';
import { createHandlerProxy } from './common';
var Tap = forwardRef(function Tap(props, ref) {
    var _a = props.component, Component = _a === void 0 ? 'div' : _a, onTouchDown = props.onTouchDown, onTouchUp = props.onTouchUp, onTouchClick = props.onTouchClick, onMouseDown = props.onMouseDown, onMouseUp = props.onMouseUp, onMouseClick = props.onMouseClick, onHoverEnter = props.onHoverEnter, onHoverLeave = props.onHoverLeave, rest = __rest(props, ["component", "onTouchDown", "onTouchUp", "onTouchClick", "onMouseDown", "onMouseUp", "onMouseClick", "onHoverEnter", "onHoverLeave"]);
    var innerRef = useRef(null);
    var handlers = {
        onTouchDown: onTouchDown,
        onTouchUp: onTouchUp,
        onTouchClick: onTouchClick,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseClick: onMouseClick,
        onHoverEnter: onHoverEnter,
        onHoverLeave: onHoverLeave,
    };
    var handlersRef = useRef(handlers);
    handlersRef.current = handlers;
    var proxyHandler = createHandlerProxy(handlersRef.current);
    useEffect(function () {
        var dom = innerRef.current;
        var relase = ftap(dom, {
            onTouchDown: proxyHandler('onTouchDown'),
            onTouchUp: proxyHandler('onTouchUp'),
            onTouchClick: proxyHandler('onTouchClick'),
            onMouseDown: proxyHandler('onMouseDown'),
            onMouseUp: proxyHandler('onMouseUp'),
            onMouseClick: proxyHandler('onMouseClick'),
            onHoverEnter: proxyHandler('onHoverEnter'),
            onHoverLeave: proxyHandler('onHoverLeave'),
        });
        return relase;
    }, []);
    return React.createElement(Component, __assign({}, rest, { ref: combineRefs(ref, innerRef) }));
});
Tap.defaultProps = {
    onTouchDown: function () { },
    onTouchUp: function () { },
    onTouchClick: function () { },
    onMouseDown: function () { },
    onMouseUp: function () { },
    onMouseClick: function () { },
    onHoverEnter: function () { },
    onHoverLeave: function () { },
};
export default Tap;
